import { useEffect, useState } from 'react';

/** Hora actual que se refresca cada `intervalMs`: para cuentas atrás visibles sin leer el reloj en el render. */
export function useNow(intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);
  return now;
}
